<app-navbar></app-navbar>
    <app-carousel></app-carousel>
    <app-servicios></app-servicios>
    <app-parallax-nosotros></app-parallax-nosotros>
    <app-clientes></app-clientes>
    <app-equipo></app-equipo>
    <app-beneficios></app-beneficios>
    <app-maps></app-maps>
    <app-footer></app-footer>
